import cn from 'classnames'
import { motion, MotionProps } from 'framer-motion'

export const ContentCard = ({
   children,
   className,
   ...props
}: MotionProps & {
   children: React.ReactNode
   className?: string
}) => {
   return (
      <motion.div
         className={cn(
            'px-9 py-6 rounded-2xl border border-[#3f3e47] bg-white/[0.02]',
            className
         )}
         {...props}
      >
         {children}
      </motion.div>
   )
}
